import axios from 'axios';

import { DataWithMetadata } from 'root/apps/QuoteMachineIntegration/state/DataWithMetadata';
import { datadogRum } from 'root/datadog/datadogRum';

export default class DepositService {
  static async fetchAll(customerID: string, creditAccountID: string) {
    try {
      const { data } = await axios.get<DataWithMetadata<any>>(
        `admin/invoicing/payment-methods/deposits?customerId=${customerID}&creditAccountId=${creditAccountID}&currency=${window.merchantos.locale.currency_code}`
      );
      return data;
    } catch (error) {
      datadogRum.addError(error, {
        customerID,
        message: `Failed to fetch admin/invoicing/payment-methods/deposits?customerId=${customerID}`,
      });
      throw error;
    }
  }
}
